<template>
	<div id="dashboard-template">
		
		<div class="container"  v-if="isAdmin">
			<!-- <div class="container"> -->
			<DBHeader />
			<DBSecondaryHeader :user="userInfo" :surveyStats="surveyStats"/>
			<div class="dashboard-content-container">
				<div class="col lg-4 md-12 dashboard-side-bar" v-show="!hideNavBar">
					<DBNav />
					<DBAccountInfo :user="userInfo"/>
				</div>
				<div class="col dashboard-primary-content" 
					:class="{ 'md-8' : !hideNavBar, 'md-12 no-left-padding' : hideNavBar}">
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

// import CreateProgressBar from '../common/Create/CreateProgressBar';
// import LoginPanel from '../common/Login/LoginPanel';
import DBHeader from '@/components/common/Dashboard/DBHeader';
import DBSecondaryHeader from '@/components/common/Dashboard/DBSecondaryHeader';
import DBNav from '@/components/common/Dashboard/DBNav';
import DBAccountInfo from '@/components/common/Dashboard/DBAccountInfo';

export default {
	components : {
		DBHeader,
		DBSecondaryHeader,
		DBNav,
		DBAccountInfo
	},
	data(){
		return {
			hideNavBar : false,
			isLoggedInChecker : this.isLoggedIn
		}	
	},
	computed : {
		userInfo(){
			return this.$store.getters.getUserInfo
		},

		isLoggedIn : function(){
			return this.$store.getters.isLoggedIn;
		},

		subRoute(){
			return this.$route;
		},

		surveyStats(){
			return this.$store.getters.surveyStats
		},

		isAdmin(){
			return this.userInfo.role === 'admin'
		}
	},
	methods : {
		
	},
	updated(){
		
		if(this.$route.name === 'editaccount'){
			this.hideNavBar = true;
		} else {
			this.hideNavBar = false;
		}
	},
	created(){
		// get stats if logged in
	
		if(this.isLoggedIn == true){
			this.$store.dispatch('getSurveyStats');
		}

		if(this.$route.name === 'editaccount'){
			this.hideNavBar = true;
		} else {
			this.hideNavBar = false;
		}
	}
}
</script>


<!-- check the api token -->
<!-- reset the survey state on logout -->


// WEBPACK FOOTER //
// src/components/pages/Dashboard.vue